
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    if (!window.app.f7.online) {
      window.app.f7.dialog.alert('Device Offline!');
      return;
    }
    if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
      window.app.f7.dialog.alert('Please Sign In!');
      return;
    }
    this.$app.preloader.show();
    window.componentVar = this;
    var params = {
      spreadsheetId: this.$route.params.id,
      range: 'Attendance!B2:B200',
      majorDimension: 'COLUMNS'
    };
    var request = gapi.client.sheets.spreadsheets.values.get(params);
    request.then(function (response) {
      window.app.f7.preloader.hide();
      window.present = 0;
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      window.tempAttnStart = response.result.values[0][0];
      window.tempAttnEnd = response.result.values[0][1];
      response.result.values[0].splice(0, 4);
      console.log(response.result.values[0]);
      window.colID = window.tempAttnStart.slice(0, -1);
      if (window.componentVar.$route.query.bonus != 'true') {
        window.tempattnArray = new Array(response.result.values[0].length + 4).fill(0);
        window.tempattnArray[0] = null;
      } else {
        window.tempattnArray = new Array(response.result.values[0].length + 4).fill('=' + window.colID + '4');
        document.getElementById('topicName').value = 'Bonus';
        window.tempattnArray[0] = 'B';
        window.present = response.result.values[0].length;
      }
      window.tempattnArray[1] = `=COUNTIF(` + window.colID + `6:` + window.colID + `,">0")`;
      window.tempattnArray[2] = 1;
      window.tempattnArray[3] = mm + '/' + dd;
      console.log(window.tempattnArray);
      window.componentVar.$setState({ data: response.result.values[0] });
    }, function (reason) {
      console.error('error: ' + reason.result.error.message);
    });
  },
  methods: {
    pushAttendance: function () {
      window.tempattnArray[2] = document.getElementById('conclassmul').value;
      console.log(window.tempattnArray);
      this.$app.preloader.show();
      let range = 'Attendance!' + window.colID + '2' + ':' + window.tempAttnEnd;
      console.log(range);
      let topic = document.getElementById('topicName').value;
      let bonus = null;
      if (this.$route.query.bonus == 'true') {
        bonus = 'B';
      }
      this.$root.pushDataToSheet(this.$route.params.id, [window.tempattnArray], 'COLUMNS', range);
      this.$root.pushDataToSheet(this.$route.params.id, [[
          window.tempattnArray[3],
          window.tempattnArray[2],
          topic
        ]], 'ROWS', 'Topics', 'APPEND');
      this.$app.dialog.alert('Attendance Taken! Present : ' + window.present + ' Out of ' + (window.tempattnArray.length - 4));
      window.app.f7.views.current.router.back();
      window.tempAttnEnd = undefined;
      window.tempAttnStart = undefined;
      window.tempattnArray = undefined;
      window.present = undefined;
      window.colID = undefined;
    },
    attnArray: function (i) {
      console.log('Clicked');
      i += 4;
      if (window.tempattnArray[i] == 0) {
        window.present++;
        window.tempattnArray[i] = '=' + window.colID + '4';
      } else {
        window.present--;
        window.tempattnArray[i] = 0;
      }
    }
  },
  id: '16d4d8c382',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n<div class="page" data-name="attendancePage">\n    <div class="navbar">\n    <div class="navbar-bg"></div>\n    <div class="navbar-inner sliding">\n        <div class="left">\n        <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n        </a>\n        </div>\n        <div class="title">Attendance Sheet</div>\n    </div>\n    </div>\n    <div class="page-content">\n    <div class="block block-strong">\n    <div class="list">\n    <ul>\n        <li>\n        <div class="item-content item-input">\n            <div class="item-inner">\n            <div class="item-title item-label">No. Of Consecutive Classes</div>\n            <div class="item-input-wrap">\n                <input id="conclassmul" name="conClass" type="number" placeholder="e.g. 2" min="1" max="10" value="1"/>\n            </div>\n            </div>\n        </div>\n        </li>\n        <li>\n        <div class="item-content item-input">\n            <div class="item-inner">\n            <div class="item-title item-label">Today\'s Topic</div>\n            <div class="item-input-wrap">\n                <input id="topicName" name="TopicEntry" type="text"/>\n            </div>\n            </div>\n        </div>\n        </li>\n        ';
      r += Template7Helpers.js.call(ctx_1, 'this.$route.query.bonus == \'true\' ? \'<p>Exclude : </p>\' : \'\'', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n    ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <li>\n        <label class="item-checkbox item-content">\n            <input type="checkbox" name="';
          r += c(ctx_2, ctx_2);
          r += '" value="';
          r += c(ctx_2, ctx_2);
          r += '"  @click="attnArray(';
          r += c(data_2 && data_2.index, ctx_2);
          r += ')"/>\n            <i class="icon icon-checkbox"></i>\n            <div class="item-inner">\n            <div class="item-title">';
          r += c(ctx_2, ctx_2);
          r += '</div>\n            </div>\n        </label>\n        </li>\n    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n    </ul>\n    </div>\n    <a href="#" class="col button button-large button-fill button-raised color-green" @click="pushAttendance">Save Attendance</a>\n    </div>\n</div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    